import React from 'react';
import PropTypes from 'prop-types';
import Component from 'BaseComponent';
import formatBytes from 'bytes';

function isPlanCompatible(plan, account) {
  const {
    sitesLimit,
    storageBytesLimit,
  } = plan.attributes;

  const storage = account.attributes.sitesSize;

  if (sitesLimit && plan.attributes.sitesCounter > sitesLimit) {
    return false;
  }

  if (storageBytesLimit && storage > storageBytesLimit) {
    return false;
  }

  return true;
}

class PlanInput extends Component {
  handleChoiceClick(value, e) {
    e.stopPropagation();
    e.preventDefault();

    this.props.onChange(value);
  }

  renderPlan(plan) {
    const { value, account, currentPlan, isCancelled } = this.props;
    const { attributes } = plan;

    const className = ['PlanPicker__item'];

    if (value === plan.id) {
      className.push('is-selected');
    }

    if (!isPlanCompatible(plan, account)) {
      className.push('is-disabled');
    }

    if (!isCancelled && currentPlan.id === plan.id) {
      className.push('is-current');
    }

    return (
      <button
        key={plan.id}
        className={className.join(' ')}
        onClick={
          isPlanCompatible(plan, account) &&
            this.handleChoiceClick.bind(this, plan.id)
        }
      >
        <div className="PlanPicker__item__title">{plan.attributes.name}</div>
        <div className="PlanPicker__item__features">
          <div className="PlanPicker__item__feature">
            <strong>Sites:</strong>
            <span>{attributes.sitesLimit || 'Unlimited'}</span>
          </div>

          <div className="PlanPicker__item__feature">
            <strong>Storage:</strong>
            <span>{attributes.storageBytesLimit ? formatBytes(attributes.storageBytesLimit, { unitSeparator: ' ' }) : 'Unlimited'}</span>
          </div>

          <div className="PlanPicker__item__feature">
            <strong>Bandwidth:</strong>
            <span>{attributes.monthlyBandwidthLimit ? formatBytes(attributes.monthlyBandwidthLimit, { unitSeparator: ' ' }) : 'Unlimited'}</span>
          </div>

          <div className="PlanPicker__item__feature">
            <strong>Montly form submissions:</strong>
            <span>{attributes.formSubmissionsLimit || 'Unlimited'}</span>
          </div>
        </div>
        <div className="PlanPicker__item__price">
          <strong>€{attributes.cost / 100}</strong>/month
        </div>
      </button>
    );
  }


  render() {
    const { plans } = this.props;

    return (
      <div className="PlanPicker">
        {
          plans
            .sort((a, b) => a.attributes.cost - b.attributes.cost)
            .map(this.renderPlan, this)
        }
      </div>
    );
  }
}

PlanInput.propTypes = {
  plans: PropTypes.array.isRequired,
  isCancelled: PropTypes.bool,
  account: PropTypes.object,
  value: PropTypes.string,
  currentPlan: PropTypes.object,
  onChange: PropTypes.func,
};

export default PlanInput;




// WEBPACK FOOTER //
// ./app/components/PlanInput.jsx